import type { FieldProps } from 'formik';
import { Field } from 'formik';
import * as React from 'react';

import Checkbox from '@components/Checkbox/index';
import InputLabel from '@components/InputLabel/index';

import { Spacer } from '@layouts/Layouts/BigTitleLayout';

interface FormikCheckboxFieldProps {
  name: string;
  label?: React.ReactNode;
  headerLabel?: string;
  onChange?: (value: boolean) => void;
  labelColor?: string;
  labelPlacement?: 'end' | 'start' | 'bottom' | 'top';
  helperText?: string;
}

const FormikCheckboxField: React.FC<FormikCheckboxFieldProps> = ({
  ...props
}) => {
  const {
    name,
    label,
    labelPlacement,
    headerLabel = '',
    onChange,
    labelColor,
    helperText,
  } = props;

  const checkboxInput = (
    <Field name={name} type="checkbox">
      {({ field, meta, form }: FieldProps<boolean>) => (
        <Checkbox
          checked={field.value}
          error={Boolean(meta.touched ? meta.error : '')}
          helperText={meta.touched ? meta.error : helperText}
          label={label}
          labelPlacement={labelPlacement}
          name={name}
          onChange={(e) => {
            form.setFieldValue(field.name, e.target.checked);
            onChange?.(e.target.checked);
          }}
        />
      )}
    </Field>
  );

  return headerLabel ? (
    <>
      <Spacer />
      <InputLabel
        label={headerLabel}
        style={{ color: labelColor ?? 'primary.main' }}
      />
      <div style={{ paddingTop: 8 }}>{checkboxInput}</div>
      <Spacer />
    </>
  ) : (
    checkboxInput
  );
};

export default FormikCheckboxField;
